export interface ProjectIndustry {
	key: string;
	label: string;
	subIndustries?: ProjectIndustry[];
}
